import { render, staticRenderFns } from "./DeleteGenreForm.vue?vue&type=template&id=1657e366&scoped=true&"
import script from "./DeleteGenreForm.vue?vue&type=script&lang=js&"
export * from "./DeleteGenreForm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGenreForm.vue?vue&type=style&index=0&id=1657e366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657e366",
  null
  
)

export default component.exports